// ****************************************************************************************************************************************************
// Creates Top Banner in inner pages

export function topBanner() {
  const topRow = $('.entityContainerRow.rowIndex-1');
  const bannerImage = topRow.find('.imageModule-single').first().find('img');
  const title = $('.entityContainer .entityContainerRow.rowIndex-1').find('.dynamicPageTitle');
  const bannerImagePath = bannerImage.attr('src')
    ? bannerImage.attr('src')
    : bannerImage.attr('data-src');

  if (bannerImagePath) {
    const cleanImgPath = bannerImagePath.replaceAll(/(?=[() ])/g, '\\');

    topRow.find('.TextMediaModule').first().hide();
    $('<div class="top-banner"></div>')
      .css('background-image', `url(${cleanImgPath})`)
      .insertAfter('header');
    $('.top-banner').append(title);
    $(topRow).remove();
  }
}
